<template>
	<div class="d-md-flex align-items-center w-100">
		<ul class="app-breadcrumbs mt-md-1 py-2 py-md-0">
			<li v-for="(item, key) in items" :key="'breadcrumb-'+key">
				<router-link :title="item.name" class="app-breadcrumbs__link" :to="item.url">{{item.name}}</router-link>
			</li>
		</ul>
		<slot/>
	</div>
</template>
<script>
export default {
	props: {
		items: Array
	}
}
</script>
<style lang="sass">
.app-breadcrumbs
	list-style: none
	margin: 0
	padding: 0
	font-size: 14px
	color: $muted

	> li
		display: block
		padding: 2px 0
		white-space: nowrap

		&::after
			position: relative
			top: -1px
			margin: 0 15px 0 12px
			content: '|'

	&__link
		display: inline-block
		color: $dark
		text-decoration: none
		white-space: nowrap
		max-width: 200px
		text-overflow: ellipsis
		vertical-align: top
		overflow: hidden

		&:hover,
		&:focus
			color: $primary
			text-decoration: underline
@media screen and (max-width: map-get($grid-breakpoints, md) - 1)
	.app-breadcrumbs
		display: flex
		overflow: auto
</style>